









































import _ from "lodash";
import rest from "@/rest";
import { Component, Vue, Watch, Prop, PropSync } from "vue-property-decorator";
import { Action, namespace } from "vuex-class";
import { List } from "linq-collections";
import { vuex } from "@/store";
import { disableBodyScroll, clearAllBodyScrollLocks } from 'body-scroll-lock';
// component
import TusFileDrop from "@/components/Shared/TusFileDrop.vue";
// interfaces
import { ExerciseVM } from "@/interfaces/ExerciseVM";
import { ParamDictionary } from "@/interfaces/ParamDictionary";

//const auth = namespace("auth");
// const globals = namespace("globals");
const globals = namespace("globals");


@Component({
  components: {
    TusFileDrop
  }
})
export default class ModuleImportDlg extends Vue {
  @PropSync("showDialog") syncedShowDialog!: boolean;

  // @globals.Getter selectedExercise: any;
  @globals.Getter selectedBundle: any;
  busy = false;
  archiveLog = "";


  mounted() {
  }

  @Watch("syncedShowDialog")
  async onShowDialogChanged(val: boolean) {
    if (this.syncedShowDialog) {
      // On dialog open
      this.archiveLog = "";

      // Disable body scroll on iOS
      this.$nextTick(async () => {
        await this.$globalHelper.delay(10);
        const modal = document.querySelector('.modal');
        disableBodyScroll(modal);
      });
    } else {
      // Dialog closing
      clearAllBodyScrollLocks();
    }
  }

  beforeDestroy() {
    clearAllBodyScrollLocks();
  }

  async onModuleArchiveFileUploaded(response: any) {
    if (!response.success) {
      this.$store.commit("ux/SB_FAILURE", {
        message: response.message,
        timeout: 0
      });
      return;
    }
    this.busy = true;

    let params = <ParamDictionary>{dictionary: {}};
    params.dictionary!["FileName"] = response.fileName;
    params.dictionary!["BundleId"] = this.selectedBundle.id;

    await rest.url("contentManager/importModuleZipArchiveFile").post(params) // importExerciseExcelOrZipArchiveFile
    .then(async (response) => {
      console.log("ModuleImportDlg: response ", response);
      if (response.exercise?.id)
        this.$emit('finished:moduleImportDlg', response.exercise);

      if (!response.log) return;

      this.archiveLog += "<br<br>" + response.log;
    })
    .catch(err => {
    })
    .finally(() => {
      this.busy = false;
    });
  }

  onCancel() {
    clearAllBodyScrollLocks();
    this.syncedShowDialog = false;
  }
}
